/* eslint-disable no-use-before-define */
import {css} from '@emotion/core'
import {mediaQueries} from '../twd'

export const displayInline = css`
    ${mediaQueries.notXs} { display: inline; }
`